import { render, staticRenderFns } from "./RootTipiBollettaView.vue?vue&type=template&id=c4e2850a&"
import script from "./RootTipiBollettaView.vue?vue&type=script&lang=ts&"
export * from "./RootTipiBollettaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports